import { render } from "./RouterLink.vue?vue&type=template&id=bb2b7420"
import script from "./RouterLink.vue?vue&type=script&lang=js"
export * from "./RouterLink.vue?vue&type=script&lang=js"

import exportComponent from "D:\\cwzl\\cw-net\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__